import IconMdi from '@components/IconMdi';
import { mdiChevronDown, mdiChevronUp, mdiFilter } from '@mdi/js';
import { clsx } from 'clsx';

type OpenFiltersFn = () => void;

type FiltersTriggerProps = {
  isFiltersOpen: boolean;
  openFilters: OpenFiltersFn;
};

const classes =
  'flex h-10 w-32 items-center justify-between border border-l-0 border-info-200 bg-info-50 p-2 py-3 hover:bg-info-50/75 rounded-r-md';

const FiltersTriggerContent = () => (
  <div data-testid="filter-btn" className="ml-auto flex items-center gap-1">
    <IconMdi path={mdiFilter} className="text-info-400" />
    <span className="text-sm leading-5 font-medium">Filters</span>
  </div>
);

const OpenFilters = ({ onClick }: { onClick: OpenFiltersFn }) => (
  <button className={classes} onClick={onClick}>
    <FiltersTriggerContent />
    <IconMdi className="ml-4" path={mdiChevronDown} />
  </button>
);

const CloseFilters = () => (
  <div className={clsx(classes, 'cursor-pointer')}>
    <FiltersTriggerContent />
    <IconMdi className="ml-4" path={mdiChevronUp} />
  </div>
);

export const FiltersTrigger = ({ isFiltersOpen, openFilters }: FiltersTriggerProps) =>
  isFiltersOpen ? <CloseFilters /> : <OpenFilters onClick={openFilters} />;
